import { FormattedMessage } from '@flipster/i18n';
import { flex } from '@flipster/styled-system/patterns';

interface Props {
  marginType: 'perpetual' | 'spot';
}

const badgeStyle = {
  textStyle: 'Text/XS/Regular',
  align: 'center',
  justify: 'center',
  h: '20px',
  px: '6px',
  borderRadius: '1000px',
};

export const MarginBadge = ({ marginType }: Props) => {
  if (marginType === 'perpetual')
    return (
      <span
        className={flex({
          ...badgeStyle,
          border: '1px solid {colors.border.default.level-2}',
          color: 'content.default.level-3',
        })}
      >
        <FormattedMessage id='Common.r250923.Perp' />
      </span>
    );

  return (
    <span
      className={flex({
        ...badgeStyle,
        border: '1px solid {colors.border.default.level-3}',
        color: 'content.default.level-5',
        backgroundColor: 'background.default.level-4',
      })}
    >
      <FormattedMessage id='Assets.r250401.Spot' />
    </span>
  );
};
